import axios from "axios";

export const AUTH_SESSION_EXPIRED_EVENT = "auth:session-expired";

const runtimeUrl = typeof window !== "undefined" && window.__ENV__ ? window.__ENV__.API_URL : undefined;

const baseURL =
  runtimeUrl ||
  process.env.REACT_APP_API_URL || // dev local
  "/api";                          // prod (proxy do Nginx)

const axiosInstance = axios.create({
  baseURL,
  timeout: 10000,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

let hasDispatchedSessionExpired = false;

const shouldHandleSessionExpired = (error) => {
  const status = error?.response?.status;
  const requestUrl = String(error?.config?.url || "").toLowerCase();

  if (status !== 401) {
    return false;
  }

  if (requestUrl.includes("login")) {
    return false;
  }

  // On the login page, 401s are expected (initial auth check, login flow) — don't fire
  if (typeof window !== "undefined" && window.location.pathname === "/login") {
    return false;
  }

  return true;
};

axiosInstance.interceptors.response.use(
  (response) => {
    hasDispatchedSessionExpired = false;
    return response;
  },
  (error) => {
    if (typeof window !== "undefined" && shouldHandleSessionExpired(error) && !hasDispatchedSessionExpired) {
      hasDispatchedSessionExpired = true;
      window.dispatchEvent(
        new CustomEvent(AUTH_SESSION_EXPIRED_EVENT, {
          detail: { url: error?.config?.url || null },
        })
      );
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
